<template >

  <v-list-item class="primary"   v-if="group" >      
      <v-list-item-title class="white--text" >{{title}}</v-list-item-title>
      <v-list-item-content></v-list-item-content>
      <v-list-item-action>
        <v-icon dark>info_outlined</v-icon>
      </v-list-item-action>
  </v-list-item>
  <v-list-item  v-else >
    <v-list-item-content>
      <v-list-item-subtitle>{{title}}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-avatar >      
      <v-list-item-subtitle>{{value + " " + dim}}</v-list-item-subtitle>
    </v-list-item-avatar>        
  </v-list-item>

  <!-- <TR v-if="group">
    <TD COLSPAN=3 class="status-grptitle">{{title}}</TD>
  </TR>
  <TR v-else class="status-tr">
    <TD class="status-title status-tr">{{title}}</TD>
    <TD class="status-value status-tr" :COLSPAN="colspan" :style="valueStyle">{{value}}</TD>
    <TD class="status-dimm status-tr" v-if="dim">{{dim}}</TD>
  </TR> -->
</template>

<script>
export default {
  name: 'lineStatus',
  props: {
    title: {
      type: String
    },
/*    groupId: {
      type: Number,
      required: true
    },
    paramId: {
      type: String,
      required: true
    }, */
    dim: {
      type: String
    },
    group: {
      type: Boolean,
      default: false
    },
    value: {},
    valueStyle: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    colspan: function () {
      return ((this.dim === undefined) || (this.dim === '')) ? 2 : 1
    }
  }
}
</script>

